import { CommonTableParams, Status as IStatus } from './common-payments';
import { PaymentsMultiuse } from './payment-links-multiuse';
import { Filters, WithAllFiltersAndPagination } from './table';

export const StringToIStatus = new Map<string, IStatus>([
	['success', 'success'],
	['active', 'active'],
	['inactive', 'inactive'],
	['pending', 'pending'],
	['expired', 'expired'],
	['error', 'error'],
]);

export const StatusMap = new Map<IStatus, string>([
	['success', 'Exitoso'],
	['active', 'Activo'],
	['aborted', 'Fallido'],
	['inactive', 'Inactivo'],
	['pending', 'Pendiente'],
	['expired', 'Expirado'],
	['error', 'Fallido'],
]);

export const StatusContentCustomLinks = new Map<string, string>([
	['success', 'Exitosos'],
	['pending', 'Pendientes'],
	['expired', 'Expirados'],
	['error', 'Fallidos'],
]);
export interface GetAllLinksCustomLinks extends CommonTableParams {
	typeSelected?: string;
}

export interface GetAllPaymentCustomLinks extends WithAllFiltersAndPagination {
	merchantCode: string;
}

export interface ExportDataParams extends Pick<Filters, 'dateRange' | 'search' | 'stateSelected'> {
	merchantCode: string;
}

export type TypesAllowed = 'unique' | 'recurrent' | 'UNIQUE' | 'RECURRENT';
export type ExpirationTypesAllowed = 'date' | 'num_payments';

export enum PATHS {
	getGraphicsData = '/v1/pl-custom/payments/graphics',
	getLastPayments = '/v1/pl-custom/payments/last',
	getAllPayments = '/v1/pl-custom/payments/table',
	getPaymentTableSales = '/v1/pl-custom/payments/sales/table',
	getAllLinks = '/v1/pl-custom/table',
	getExportPaymentsData = '/v1/pl-custom/payments/export',
	getStatisticsSales = '/v1/pl-custom/payments/sales/statistics',
	getExportPaymentsDataSales = '/v1/pl-custom/payments/sales/export',
}

export interface CreatePaymentLinkCustom {
	paymentType: 'UNIQUE' | 'RECURRENT';
	amountType: string;
	order_amount: number | undefined;
	order_amount_min: number | undefined;
	order_amount_max: number | undefined;
	num_payments: number | undefined;
	name: string;
	init_expired_at: string | undefined;
	end_expired_at: string | undefined;
	fields: any;
	merchant_code: string;
	merchant_api_token: string;
	customer_email: string;
	is_rut_block: boolean;
	concat: string;
	payment_completed_url: string;
	payment_cancellation_url: string;
	metadata: any;
}

export interface CreatePaymentLinkCustomResponse {
	url_presession_token: string;
	presession_token: string;
}

export interface SendPaymentCustomLinkBy {
	merchantCode: string;
	wayToShare: string;
	paymentLink?: string;
	email?: string;
	phone?: string;
	presessionToken: string;
}

export interface SendPaymentLinkCustomSMS {
	merchantCode: string;
	phoneNumber: string;
	presessionToken: string;
}

export interface EndPaymentLinkCustom {
	merchantCode: string;
	presessionToken: string;
	comment?: string;
}

export interface PaymentLinkCustomResponse {
	pl_custom_qr: string;
	pl_custom_url: string;
}

export interface PaymentLinkCustomResponseCode {
	code: string;
}

export interface PaymentLinkCustomShareLink {
	msg: string;
}

export interface CreateNewPaymentLinkCustomParams {
	merchantCode: string;
	reference: string;
	numPayments?: number;
	amount: number;
	description?: string;
	expirationType: 'num_payments' | 'date';
	paymentType: 'unique' | 'recurrent';
	from?: string;
	to?: string;
}

export interface PausePaymentLinkCustomParams {
	token: string;
	merchantCode: string;
}

export interface ResponsePLCustom {
	pl_custom_qr: string | null;
	pl_custom_url: string | null;
}

export type CustomLinksTypes = 'PL' | 'pending' | 'expired' | 'error';

export type CustomLinkStatus = 'active' | 'inactive';

export type CustomLinkSubStatus =
	| 'active'
	| 'completed'
	| 'expired'
	| 'finalized'
	| 'paused'
	| 'pending';

export type KeyTypes = 'rut' | 'names' | 'email';
export interface Field {
	type: string;
	type_var: string;
	key: KeyTypes;
	required: boolean;
	label?: string | null;
	placeholder?: string | null;
	value: string | null;
}

export type AmountType = 'VARIABLE' | 'FIXED';

export interface CustomLink {
	name: string;
	amount: string;
	amounttype: AmountType;
	createdatdate: string;
	createdattime: string;
	description: string;
	endexpiredatdate: string;
	endexpiredattime: string;
	endexpiredat: string;
	expirationtype: string;
	initexpiredatdate: string;
	initexpiredattime: string;
	initexpiredat: string;
	ismerchantorderidblock: boolean;
	isorderamountblock: boolean;
	merchantcode: string;
	merchantorderid: string;
	numpayments: number;
	numsuccesspayments: number;
	numsuccesspayments_remaining: number;
	openings: number;
	fields: Field[];
	orderamountmax: string;
	orderamountmin: string;
	payments: PaymentsMultiuse[];
	paymenttype: TypesAllowed;
	status: CustomLinkStatus;
	sub_status: CustomLinkSubStatus;
	token_qr: string;
	token: string;
	token_url: string;
}

export interface EditPaymentLinkCustom {
	presession_token: string;
	merchant_code: string;
	payment_type?: TypesAllowed;
	amount_type?: AmountType;
	name?: string;
	order_amount?: number;
	order_amount_min?: number;
	order_amount_max?: number;
	num_payments?: number;
	end_expired_at?: string;
	has_end_expiration_date: boolean;
	fields?: Field[];
}

export interface ResponseCode {
	code: string;
}
